<template>
    <div>
        <div style="margin: 1px 40px 40px;"></div>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="收费明细项目编码" required prop="auxItemCode">
                            <el-input ref="ipt01" v-model="form.auxItemCode" placeholder="请输入收费明细项目编码" maxlength="30"
                                show-word-limit :disabled="!create"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                     <el-col :span="24">
                        <el-form-item label="收费明细项目名称" required prop="auxItemName">
                            <el-input ref="ipt01" v-model="form.auxItemName" placeholder="请输入收费明细项目名称" maxlength="100"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="收费明细项目单位" prop="auxItemUnit">
                            <el-input ref="ipt01" v-model="form.auxItemUnit" placeholder="请输入收费明细项目单位" maxlength="30"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="收费明细项目标准" prop="auxItemStd">
                            <el-input ref="ipt01" v-model="form.auxItemStd" placeholder="请输入收费明细项目标准" maxlength="18"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="收费明细项目备注" prop="auxItemRemark">
                            <el-input ref="ipt01" v-model="form.auxItemRemark" placeholder="请输入收费明细项目备注" maxlength="100"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
                </el-form-item>
                <el-row><el-col></el-col></el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
    import _ from "lodash"

    let _kits, _form
    export default {
        props: ["entity", "mode"],
        data() {
            var checkAuxItemStd = (rule, value, callback) => {
                const reg = /^([1-9]\d*|0)(\.\d{1,4})?$/;
                if (value !=null && value != "" && !reg.test(value)) {
                    callback(new Error("收费标准金额格式错误（4位小数的数字）"));
                } else {
                    callback();
                }
            };
            let create = !this.entity.auxItemCode
            let form = {
                agencyCode: this.entity.agencyCode,
                itemCode: this.entity.itemCode,
                itemName: this.entity.itemName,
                auxItemCode: this.entity.auxItemCode,
                auxItemName: this.entity.auxItemName,
                auxItemUnit: this.entity.auxItemUnit,
                auxItemStd: this.entity.auxItemStd,
                auxItemRemark: this.entity.auxItemRemark
            }
            let data = {
                fileList: [],
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                einvtypeCodeOptions: [],
                create,
                form,
                formRules: {
                    auxItemCode : [
                        { required: true, message: "请输入项目编码", trigger: "blur" }
                    ],
                    auxItemName : [
                        { required: true, message: "请输入项目名称",  trigger: "blur" }
                    ],
                    auxItemStd :[
                        { validator: checkAuxItemStd, trigger: "blur" }
                    ]
                },
                einvoiceTypeOptions: [],
                supervisorSealOptions: []
            }
            console.log("data is ", data)
            return data
        },
        methods: {
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit();
            }
        },
        created() {
            _kits = this.$kits()
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: this.create ? "SAVEAGENCYITEMAUX" : "UPDATEAGENCYITEMAUX"
            })
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
        }
    }
</script>
